import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Loupe de recherche — lentille menthe pleine + manche bleu épais.
 * Affordance pour les champs de recherche : visible mais sobre.
 */
export const SearchIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Lentille remplie menthe (opaque) */}
      <circle cx="10" cy="10" r="7.25" fill="var(--equiply-icon-bg)" />
      {/* Contour bleu, trait épais */}
      <circle cx="10" cy="10" r="7.25" stroke="var(--equiply-icon-fg)" strokeWidth="2" />
      {/* Reflet (touche de blanc en haut-gauche pour donner du relief) */}
      <path
        d="M6 7.5a4.5 4.5 0 0 1 3.5-2.5"
        stroke="hsl(var(--background))" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"
      />
      {/* Manche */}
      <path
        d="M15.5 15.5l5 5"
        stroke="var(--equiply-icon-fg)" strokeWidth="2.25" strokeLinecap="round"
      />
    </svg>
  ),
);
SearchIcon.displayName = "SearchIcon";
